<template>
  <b-container fluid class="new-password">
    <div class="my-5">
      <b-row align-h="center" align-v="center">
        <b-col sm="12" md="8" lg="6" xl="4">
          <b-card no-body class="v2_box_teal">
            <b-card-header class="new-password__card-header v2_box_teal_header">
              Create New Password
            </b-card-header>
            <b-card-body class="new-password__card-body">
              <b-form @submit.prevent="save">
                <b-form-group class="password-group">
                  <b-row>
                    <b-col cols="10" sm="11" md="11" lg="11" xl="11">
                      <div class="icon-input">
                        <span class="icon-input__icon">
                          <i class="mdi mdi-lock" aria-hidden="true" />
                        </span>
                        <b-form-input
                          :type="isPasswordVisible ? 'text' : 'password'"
                          class="pl-5 p-3 phairify-border-grey height_auto v2_font_size_18 v2_color_black form-control"
                          v-model="$v.password.$model"
                          placeholder="Password"
                          :state="validateState('password')"
                        />
                      </div>
                    </b-col>
                    <b-col cols="2" sm="1" md="1" lg="1" xl="1">
                      <i
                        aria-hidden="true"
                        :class="[
                          'mdi',
                          {
                            'mdi-eye-off': isPasswordVisible,
                            'mdi-eye': !isPasswordVisible,
                          },
                          'clickable',
                          'icon-input__icon-right',
                        ]"
                        @click="isPasswordVisible = !isPasswordVisible"
                      />
                    </b-col>
                  </b-row>
                  <div
                    v-show="$v.password.$anyError"
                    tabindex="-1"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    class="invalid-feedback"
                  >
                    {{ passwordInvalidFeedback }}
                  </div>
                </b-form-group>
                <b-col cols="12" class="text-center">
                  <b-btn
                    variant="v2_primary"
                    type="submit"
                    :disabled="saveLoading"
                  >
                    <b-spinner v-if="saveLoading" small />
                    <span v-else>Submit</span>
                  </b-btn>
                </b-col>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { minLength, required } from 'vuelidate/lib/validators';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import Api from '@/providers/Api';
import Help from '@/providers/Help';
import { SET_PASSWORD_RESET_REQUIRED_MUTATION, SIGN_OUT_ACTION } from '@/store';

export default {
  name: 'UpdateTemporaryPassword',
  mixins: [validationMixin],
  data: function () {
    return {
      password: null,
      saveLoading: false,
      isPasswordVisible: false,
    };
  },
  validations: {
    password: {
      required,
      minLength: minLength(8),
    },
  },
  computed: {
    passwordInvalidFeedback: function () {
      return !this.$v.password.minLength
        ? 'Password should be at least 8 characters'
        : 'This field is required';
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    save: async function () {
      this.$v.$touch();

      if (this.$v.$anyError) {
        return;
      }
      this.saveLoading = true;
      try {
        await Api.updateTemporaryPassword(this.password);
        this.$store.commit(SET_PASSWORD_RESET_REQUIRED_MUTATION, false);
        const okCallback = async () => {
          await this.$store.dispatch(SIGN_OUT_ACTION);
          this.$router.push('/login');
        };
        Help.confirm.show(
          `
            <div>
                <br>
                  <span class="v2_color_black ">Your password has been updated successfully, click on OK to login.</span>
                <br>
            </div>
          `,
          'OK',
          okCallback,
          okCallback,
          true,
          true
        );
      } catch (response) {
        handleServerErrorWithValidation(response, this.$toasted);
      } finally {
        this.saveLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../../../sass/variables_mixins';

.new-password {
  .invalid-feedback {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    display: block;
  }

  .new-password__card-header {
    padding: 10px 20px;
  }

  .new-password__card-body {
    padding: 15px 20px;

    i.mdi:not([class*='mdi-eye']) {
      font-size: $phairify_icon-size_large;
      color: $phairify_v2_color_secondary_lime;
    }
  }

  .password-group {
    div {
      outline: none !important;
    }
    .password-row {
      .icon-input:focus {
        outline: rgb(77, 144, 254) auto 1px !important;
      }
    }
  }
}
</style>
